import React from "react";

// Mientras no haya datos se muestra un solo mensaje en lugar de las tres
// tablas: el error del backend cuando la consulta no se pudo armar, o la
// indicación de consultar con los filtros elegidos
export const MensajeReporteSinDatos = ({ mensajeError }) => (
    <div className="text-center py-5">
        <h3>
            {mensajeError ||
                "Seleccione los filtros y presione Consultar para ver el periodo a cerrar"}
        </h3>
    </div>
);
